import { call, put, takeLatest } from 'redux-saga/effects'
import { callSecureApi } from './api/callApi'
import { Endpoints } from 'src/constants/endpoints'
import { FetchTableConfig, UpsertTableConfig } from 'src/constants/actionTypes'
import { AsyncAction } from 'src/utils/reduxUtils'
import { ColumnPreferences } from 'src/interfaces/tableConfig'

interface FetchTableConfigPayload {
  tableKey: string
}

interface FetchTableConfigResponse {
  preferences?: ColumnPreferences
}

interface UpsertTableConfigPayload {
  tableKey: string
  preferences: ColumnPreferences
}

function* onFetchTableConfig(
  action: AsyncAction<FetchTableConfigPayload, FetchTableConfigResponse>,
) {
  try {
    const { payload }: { payload: FetchTableConfigResponse } = yield call(
      callSecureApi,
      Endpoints.FetchTableConfig,
      {
        params: [{ field: ':tableKey', value: action.payload.tableKey }],
      },
    )

    yield put(FetchTableConfig.success(payload))

    if (action.next) {
      action.next(null, payload)
    }
  } catch (error: any) {
    yield put(FetchTableConfig.failed(error))

    if (action.next) {
      action.next(error?.payload?.message || 'Failed to fetch table config')
    }
  }
}

function* onUpsertTableConfig(action: AsyncAction<UpsertTableConfigPayload, void>) {
  const { tableKey, preferences } = action.payload

  try {
    yield call(callSecureApi, Endpoints.UpsertTableConfig, {
      method: 'PUT',
      params: [{ field: ':tableKey', value: tableKey }],
      body: { preferences },
    })

    yield put(UpsertTableConfig.success())

    if (action.next) {
      action.next(null)
    }
  } catch (error: any) {
    yield put(UpsertTableConfig.failed(error))

    if (action.next) {
      action.next(error?.payload?.message || 'Failed to save table config')
    }
  }
}

export function* tableConfigSaga() {
  yield takeLatest(FetchTableConfig.type.REQUEST, onFetchTableConfig)
  yield takeLatest(UpsertTableConfig.type.REQUEST, onUpsertTableConfig)
}
